import { TextInputProps } from '@ardoq/forms';
import { Locale } from '@ardoq/locale';

export enum DatePickerCloseTriggerKeys {
  ENTER = 'Enter',
  ESCAPE = 'Escape',
  TAB = 'Tab',
}

export type DateTimeInputSpecificProps = Pick<
  TextInputProps,
  | 'inputId'
  | 'placeholder'
  | 'label'
  | 'hasError'
  | 'errorMessage'
  | 'hasWarning'
  | 'warningMessage'
  | 'hintMessage'
  | 'isDisabled'
  | 'isReadOnly'
  | 'autoFocus'
  | 'indicator'
  | 'isRequired'
  | 'aria-label'
> & { hideIcon?: true };
type Formatter = (date: Date | null, locale: Locale) => string;
type DateTimePickerConfigBase = {
  readonly minDate?: Date;
  readonly maxDate?: Date;
  readonly useTimePicker?: boolean;
  readonly locale?: Locale;
};
export type DateTimePickerDropdownConfig = DateTimePickerConfigBase & {
  readonly containerStyle?: React.CSSProperties;
  readonly disabledDayExplanationText?: string;
};
export type DateTimePickerConfig = DateTimePickerConfigBase & {
  readonly formatter?: Formatter;
  readonly disabledDayExplanationText?: string;
};
